export default "__VITE_ASSET__3bbc6c02__"